import { createContext, useContext, type ReactNode } from 'react';

// Ambient org-id access for widget blocks that need to fetch bound
// platform data (Leadership Directory, Calendar, Unit Identity Card) —
// avoids threading orgId through BlockRenderer/the registry's View prop
// contract, which every other (unbound) block type would otherwise have
// to declare and ignore. Provided once, high up, wherever a site's blocks
// are rendered (PublicSite.tsx, StudioCanvas.tsx).
const SiteOrgContext = createContext<string | null>(null);

export function SiteOrgProvider({ orgId, children }: { orgId: string | null; children: ReactNode }) {
  return <SiteOrgContext.Provider value={orgId}>{children}</SiteOrgContext.Provider>;
}

export function useSiteOrgId(): string | null {
  return useContext(SiteOrgContext);
}
